import * as React from "react";
import Component from "../../AbstractComponent";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import Select from "../../Partials/Material/Select";
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "../../Partials/Material/TextField";
import DialogActions from '@material-ui/core/DialogActions';

export class ChargeTypeCreate extends Component {
  public state = {
    label: "",
    chargeClass: !!this.props.chargeTypeSelectField ? this.props.chargeTypeSelectField : ""
  };

  constructor(public props) {
    super(props);
  }

  public onCancelType = (): any => {
    if (typeof this.props.onCancelType === "function") {
      this.props.onCancelType.call(this);
    }
  }

  public onSaveType = (): any => {
    if (typeof this.props.onSaveType === "function") {
      this.props.onSaveType.call(this, {
        label: this.state.label,
        chargeClass: this.state.chargeClass
      });
    }
  }

  public updateChargeClass = (event) => {
    this.setState({
      chargeClass: event.target.value
    });
  }

  public updateChargeName = (event) =>{
    this.setState({
      label: event.target.value
    })
  }

  public render() {
    return (
      <div>
        <div>
          <TextField
            autoComplete="off"
            id="label"
            className="form-element full-size scroll-to-label"
            type="text"
            label={this.trans("charge-type-name")}
            value={this.state.label}
            onChange={this.updateChargeName}
            autoFocus={true}
            variant="standard"
            error={!!this.getErrorFor("label")}
          />
          {!!this.getErrorFor("label") && <div className="component-error-text">{this.getErrorFor("lebel")}</div>}
          {
            !!this.props.chargeTypeSelectField ?
              <Select
                className="form-element full-size form-input scroll-to-chargeClass correct-label-position"
                error={this.getErrorFor("chargeClass")}
                disabled={true}
                value={this.props.chargeTypeSelectField === "Payable" ? ChargeClassContainer.pickIdFromLabel("Payable") : ChargeClassContainer.pickIdFromLabel("Receivable")}
                htmlFor="chargeClass"
                label={this.trans("charge-class-id-type")}
                name="chargeClass" 
                id="chargeClass"
              >
                {
                  <MenuItem
                    value={this.props.chargeTypeSelectField === "Payable" ? ChargeClassContainer.pickIdFromLabel("Payable") : ChargeClassContainer.pickIdFromLabel("Receivable")}
                    key={this.props.chargeTypeSelectField === "Payable" ? ChargeClassContainer.pickIdFromLabel("Payable") : ChargeClassContainer.pickIdFromLabel("Receivable")}
                  >
                    {this.props.chargeTypeSelectField === "Payable" ? this.trans(`${ChargeClassContainer.pickLabelFromId(ChargeClassContainer.pickIdFromLabel("Payable"))}`) : this.trans(`${ChargeClassContainer.pickLabelFromId(ChargeClassContainer.pickIdFromLabel("Receivable"))}`)}
                  </MenuItem>
                }
              </Select>
            :
              <Select
                className="form-element full-size form-input scroll-to-chargeClass correct-label-position"
                error={this.getErrorFor("chargeClass")}
                value={this.state.chargeClass}
                onChange={this.updateChargeClass}
                htmlFor="chargeClass"
                label={this.trans("charge-class-id-type")}
                name="chargeClass" 
                id="chargeClass"
              >
                {
                  Object.keys(this.props.globalTypes?.ChargeClass || {}).map(chargeClass => {
                    let chargeTypeClass =  this.props.globalTypes?.ChargeClass?.[chargeClass]
                    if (!chargeTypeClass.label) {
                      return;
                    }
                    return (
                      <MenuItem value={chargeTypeClass.label} key={chargeTypeClass.id}>{this.trans(`${chargeTypeClass.label}`)}</MenuItem>
                    );
                  })
                }
              </Select>
          }
        </div>

        <DialogActions>
          <div className="button-container">
            <Button
              color="primary"
              onClick={this.onCancelType}
            >
              {this.trans("dialog-button/cancel")}
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={this.onSaveType}
            >
              {this.trans("dialog-button/create")}
            </Button>
          </div>
        </DialogActions>
      </div>
    );
  }
}
